var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function CropIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 15V9H3.99562C3.44576 9 3 8.55614 3 8C3 7.44772 3.44995 7 3.99562 7H7V4.00427C7 3.44962 7.44386 3 8 3C8.55228 3 9 3.45098 9 4.00427V7H16.0044C16.2786 7 16.5268 7.11036 16.7069 7.28996C16.8887 7.47472 17 7.72297 17 7.9954V15H20.0044C20.5542 15 21 15.4439 21 16C21 16.5523 20.5501 17 20.0044 17H7.99562C7.44832 16.9976 7.00482 16.5548 7.00004 16.006C7.00001 16.004 7 10.5034 7 10.5034C7 10.2254 7.22168 10 7.50468 10H8.49532C8.77404 10 9 10.225 9 10.5034V15H15ZM15 18.4954C15 18.2218 15.2217 18 15.5047 18H16.4953C16.774 18 17 18.2255 17 18.4954V20.001C17 20.5528 16.5561 21 16 21C15.4477 21 15 20.5509 15 20.001V18.4954Z", fill: "" })));
}
export var CropIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: CropIconInner }, props))); };
//# sourceMappingURL=CropIcon.js.map